import React, { useEffect, useState } from 'react';
import GmModal from 'app/shared/modal/modal';
import styles from '../view.module.css';

export const BlogRejectModal = ({ show, onClose, onSubmit, submitting = false }) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) {
      setReason('');
      setError('');
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleaned_reason = reason.trim();

    if (!cleaned_reason) {
      setError('Rejection reason is required.');
      return;
    }

    setError('');
    const success = await onSubmit(cleaned_reason);
    if (success) onClose();
  };

  return (
    <GmModal
      title="Reject blog"
      show_title
      show_modal={show}
      onClose={onClose}
      bodyClassName={styles.rejectModal}
    >
      <form className={styles.rejectForm} onSubmit={handleSubmit}>
        <label className={styles.rejectLabel} htmlFor="blog-rejection-reason">
          Reason
        </label>
        <textarea
          id="blog-rejection-reason"
          className={styles.rejectInput}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError('');
          }}
          placeholder="Enter rejection reason"
          rows={4}
          autoFocus
        />
        {error && <div className={styles.rejectError}>{error}</div>}

        <div className={styles.rejectActions}>
          <button
            type="button"
            className={styles.rejectCancelBtn}
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button type="submit" className={styles.rejectSubmitBtn} disabled={submitting}>
            {submitting ? 'Submitting…' : 'Submit rejection'}
          </button>
        </div>
      </form>
    </GmModal>
  );
};
